import React from "react"
import { Box } from "@mui/system"
import { useTranslation } from "react-i18next"
import Button from "src/components/Button"
import { useDispatch } from "react-redux"
import { actions, fetchFerroBarUserDataAsync } from "src/state/xFer"
import { useAction } from "src/hooks/useAction"
import { useUserFerroBar } from "src/state/xFer/hooks"
import useFerroBarHandlers from "../../hooks/useFerroBarHandlers"
import { useActiveWeb3React } from "src/hooks"
import { usePoolTokenBalances } from "src/state/wallet/hooks"
import { XFER } from "src/constants"
import { BIG_ZERO } from "src/constants/bigNumber"
import { enqueueToast } from "src/components/Toastify"
import Web3Status from "src/components/Web3Status"

import { useIsMobile } from "src/hooks/useIsMobile"

const ActionButtons = () => {
  const { t } = useTranslation()

  const { account } = useActiveWeb3React()
  const tokenBalances = usePoolTokenBalances()
  const isMobile = useIsMobile()
  const balance = tokenBalances?.[XFER.symbol] || BIG_ZERO

  const openStakeModal = useAction(actions.setOpenedStakeModal, {
    isUnstaking: false,
  })
  const openUnstakeModal = useAction(actions.setOpenedStakeModal, {
    isUnstaking: true,
  })

  const dispatch = useDispatch()

  const { barData } = useUserFerroBar()
  const { allowance } = barData

  const { onApprove } = useFerroBarHandlers()

  const hasStakedFer = balance && balance.gt("0")
  const isEnabled = allowance && allowance.gt("0")

  const handleApprove = async () => {
    try {
      await onApprove()
      if (account) {
        dispatch(fetchFerroBarUserDataAsync(account))
      }
    } catch (e) {
      console.error(e)
      enqueueToast("error", t("FER is not approved"), t("Transaction Failed"))
    }
  }

  if (!account) {
    return <Web3Status fullWidth />
  }

  if (isEnabled && hasStakedFer) {
    return (
      <Box display={["block", "flex"]} justifyContent="space-between">
        <Button onClick={openStakeModal} fullWidth>
          {t("Stake More")}
        </Button>
        <Button
          onClick={openUnstakeModal}
          fullWidth
          ml={isMobile ? 0 : 1}
          mt={isMobile ? 1 : 0}
          kind="outline"
        >
          {t("Unstake")}
        </Button>
      </Box>
    )
  }

  return (
    <Box>
      <Box display={["block", "flex"]} justifyContent="space-between">
        <Button onClick={handleApprove} disabled={isEnabled} fullWidth>
          {isEnabled ? t("Enabled") : t("Enable")}
        </Button>
        <Button
          onClick={openStakeModal}
          disabled={!isEnabled}
          fullWidth
          ml={isMobile ? 0 : 1}
          mt={isMobile ? 1 : 0}
        >
          {t("Stake FER")}
        </Button>
      </Box>
    </Box>
  )
}

export default ActionButtons
